var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "institutional-trading"
  }, [_c("section", {
    staticClass: "institutional-trading__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "机构交易版",
      description: "同花顺机构交易版依托大数据、AI技术为专业投资者提供如篮子交易、策略交易、算法交易等丰富的个性化交易功能，\n      有效解决委托延时高、交易成功率低两大核心交易问题，为投资者带来极致的速度体验。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "institutional-trading__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "institutional-trading__order-wrapper"
  }, [_c("Order")], 1), _c("section", {
    staticClass: "institutional-trading__picture-text-wrapper"
  }, [_c("picture-text")], 1), _c("section", {
    staticClass: "institutional-trading__value-wrapper"
  }, [_c("Value")], 1), _c("section", {
    staticClass: "institutional-trading__cases-wrapper"
  }, [_c("Cases")], 1), _c("section", {
    staticClass: "institutional-trading__appointment-wrapper"
  }, [_c("Appointment2", {
    staticClass: "appointment"
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };